export enum Locales {
  en = 'en',
  fr = 'fr',
  ar = 'ar',
}
